import React from 'react'
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import "./websitesolutions.scss";
import PageHero from '../Components/PageHero'

function WebsitePage() {
  return (
    <>
      
      <PageHero
       title="Website Management"
       subtitle="We manage your website professionally"
      /> 

      <section className="website-solutions-section py-5">
            <Container>
      
              {/* Section Header */}
              <div className="text-center mb-5">
                <Badge bg="primary" className="px-3 py-2 mb-3">
                  Our Website Development Services
                </Badge>
                <h2 className="fw-bold display-6">
                  Professional Website Design & Development Solutions
                </h2>
                <p className="text-muted">
                  We design and develop modern, responsive, SEO-friendly websites
                  tailored to your business goals and digital growth strategy.
                </p>
              </div>
      
              <Row className="g-4">
      
                {/* Static Website */}
                <Col md={4}>
                  <Card className="solution-card h-100 shadow-lg border-0">
                    <Card.Body>
                      <h4 className="fw-bold border-bottom border-2 pb-2">Static Website</h4>
                      <p className="text-muted">
                        A fast, secure, and cost-effective website suitable for
                        small businesses, startups, and personal portfolios.
                      </p>
      
                      <h6 className="fw-bold mt-3">Key Features:</h6>
                      <ul className="feature-list">
                        <li><CheckCircleFill className="icon" /> Responsive Design</li>
                        <li><CheckCircleFill className="icon" /> SEO Friendly Structure</li>
                        <li><CheckCircleFill className="icon" /> Fast Loading Speed</li>
                        <li><CheckCircleFill className="icon" /> Secure Hosting Setup</li>
                      </ul>
      
                      <h6 className="fw-bold mt-3">Advantages:</h6>
                      <p className="text-muted">
                        Low maintenance cost, high security, and ideal for showcasing
                        company information and services.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
      
                {/* Dynamic Website */}
                <Col md={4}>
                  <Card className="solution-card h-100 shadow-lg border-0">
                    <Card.Body>
                      <h4 className="fw-bold border-bottom border-2 pb-2">Dynamic Website</h4>
                      <p className="text-muted">
                        Advanced website solution with database integration and
                        content management capabilities.
                      </p>
      
                      <h6 className="fw-bold mt-3">Key Features:</h6>
                      <ul className="feature-list">
                        <li><CheckCircleFill className="icon" /> Admin Panel Control</li>
                        <li><CheckCircleFill className="icon" /> Database Integration</li>
                        <li><CheckCircleFill className="icon" /> User Login & Authentication</li>
                        <li><CheckCircleFill className="icon" /> Custom Modules & APIs</li>
                      </ul>
      
                      <h6 className="fw-bold mt-3">Advantages:</h6>
                      <p className="text-muted">
                        Real-time content updates, better scalability, and suitable
                        for schools, institutions, and growing businesses.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
      
                {/* E-Commerce Website */}
                <Col md={4}>
                  <Card className="solution-card h-100 shadow-lg border-0">
                    <Card.Body>
                      <h4 className="fw-bold border-bottom border-2 pb-2">E-Commerce Website</h4>
                      <p className="text-muted">
                        Complete online store solution to sell products and services
                        securely with payment integration.
                      </p>
      
                      <h6 className="fw-bold mt-3">Key Features:</h6>
                      <ul className="feature-list">
                        <li><CheckCircleFill className="icon" /> Product Management</li>
                        <li><CheckCircleFill className="icon" /> Secure Payment Gateway</li>
                        <li><CheckCircleFill className="icon" /> Order & Inventory Management</li>
                        <li><CheckCircleFill className="icon" /> Customer Dashboard</li>
                      </ul>
      
                      <h6 className="fw-bold mt-3">Advantages:</h6>
                      <p className="text-muted">
                        24/7 online sales, automated order processing, and increased
                        business revenue through digital presence.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
      
              </Row>
      
              {/* Why Choose Us Section */}
              <div className="text-center mt-5">
                <h3 className="fw-bold mb-3">Why Choose Uiplus Technologies?</h3>
                <p className="text-muted">
                  We combine creativity, modern technologies, and business
                  understanding to deliver websites that are secure, scalable,
                  and performance-driven.
                </p>
      
                <div className="mt-3">
                  <Button variant="primary" size="lg" className="px-4">
                    Request Consultation
                  </Button>
                </div>
              </div>
      
            </Container>
          </section>
    </>
  )
}

export default WebsitePage
